import { useState, useCallback } from "react"
import { Text } from "@react-three/drei"
import { Select } from "@react-three/postprocessing"
import { Price } from "./Price"
import { Desk, Chair, Monitor, Keyboard, Bookshelf, DeskLamp, Plant, Floor, Walls, Rug, CoffeeMug } from "./Furniture"

export function Scene(props) {
  const [hovered, hover] = useState(null)
  const over = (name) => (e) => {
    e.stopPropagation()
    hover(name)
  }
  const out = () => hover(null)
  const prices = {
    BEKANT: 349,
    MARKUS: 229,
    SAMSUNG: 449,
    TERTIAL: 12,
    KALLAX: 89,
    FEJKA: 5,
  }
  const price = prices[hovered] ?? 349
  return (
    <>
      <group {...props}>
        <Floor />
        <Walls />
        <Rug />

        {/* Desk - BEKANT */}
        <Select enabled={hovered === "BEKANT"} onPointerOver={over("BEKANT")} onPointerOut={out}>
          <Desk position={[0, 0, -1.2]} />
          <Keyboard position={[0, 0, -1.2]} />
          <CoffeeMug position={[-0.55, 0, -1.1]} />
        </Select>

        {/* Chair - MARKUS */}
        <Select enabled={hovered === "MARKUS"} onPointerOver={over("MARKUS")} onPointerOut={out}>
          <Chair position={[0, 0, -0.3]} />
        </Select>

        {/* Monitor - SAMSUNG */}
        <Select enabled={hovered === "SAMSUNG"} onPointerOver={over("SAMSUNG")} onPointerOut={out}>
          <Monitor position={[0, 0, -1.5]} />
        </Select>

        {/* Lamp - TERTIAL */}
        <Select enabled={hovered === "TERTIAL"} onPointerOver={over("TERTIAL")} onPointerOut={out}>
          <DeskLamp position={[-0.6, 0, -1.3]} />
        </Select>

        {/* Bookshelf - KALLAX */}
        <Select enabled={hovered === "KALLAX"} onPointerOver={over("KALLAX")} onPointerOut={out}>
          <Bookshelf position={[-2.2, 0, -1.5]} />
        </Select>

        {/* Plant - FEJKA */}
        <Select enabled={hovered === "FEJKA"} onPointerOver={over("FEJKA")} onPointerOut={out}>
          <Plant position={[0.65, 0.74, -1.3]} />
        </Select>
      </group>

      <Text position={[1.5, 1.6, -1]} color="black" fontSize={0.15} font="Inter-Regular.woff" letterSpacing={-0.05}>
        {hovered ? hovered : "BEKANT"}
      </Text>
      <Price value={price} position={[-2.5, 0.3, -0.5]} rotation={[0, 0.3, 0]} />
    </>
  )
}
